import { render, staticRenderFns } from "./PProcessInfoModal.vue?vue&type=template&id=067fd2b7&"
import script from "./PProcessInfoModal.vue?vue&type=script&lang=js&"
export * from "./PProcessInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports